module.exports = __webpack_public_path__ + "static/img/sustainability_program_03.72ef0a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/sustainability_program_03.jpg
// module id = q72V
// module chunks = 0